import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap5';

import ButtonCollapse from './ButtonCollapse';

export default function Steps({ templateId, template }) {
  const stepItem = (step) => (
    <li
      key={`${templateId}-step-${step.id}`}
      className={step.predefined ? 'predefined' : ''}
    >
      {step.title}
    </li>
  );

  const mobileVersion = (
    <Col className="main d-md-none">
      {template.attributes.sessions}
      {' '}
      Sessions

      <ol className={`${templateId} collapse m-0 fw-light`}>
        {template.attributes.steps.map((step) => stepItem(step))}
      </ol>

      <ButtonCollapse templateId={templateId} />
    </Col>
  );

  return (
    <>
      {mobileVersion}

      <Col md="6" className="main d-none d-md-block">
        <ol className="m-0 fw-light">
          {template.attributes.steps.slice(0, 6).map((step) => stepItem(step))}

          {template.attributes.steps.length > 6 && (
            <div className={`${templateId} collapse`}>
              {template.attributes.steps.slice(6).map((step) => stepItem(step))}
            </div>
          )}
        </ol>

        {template.attributes.steps.length > 6 && <ButtonCollapse templateId={templateId} />}
      </Col>
    </>
  );
}

Steps.propTypes = {
  templateId: PropTypes.string.isRequired,
  template: PropTypes.object.isRequired,
};
